import api from './api';

const orderService = {
  create: (data) => api.post('/orders', data),
  getMyOrders: (params) => api.get('/orders', { params }),
  getById: (id) => api.get(`/orders/${id}`),
  getMerchantOrders: (params) => api.get('/orders/merchant/my-orders', { params }),
  updateStatus: (id, status, extra = {}) => api.put(`/orders/${id}/status`, { status, ...extra }),
  cancelOrder: (id, reason) => api.put(`/orders/${id}/cancel`, { reason }),
  requestReturn: (id, data) => api.post(`/orders/${id}/return`, data),
};

export default orderService;
